import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";
class LoginStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.user = "";
        this.userId = "";
        this.details = "";
        this.profiles = [];
        this.errorMsg = "";
        this.otp = false;
        this.loader = false;
        this.passOtp = "";
        this.countryCode = [];
        this.number = "";
        this.happayIdField = "";
        this.encryptionKey = {};
    }

    _getField(type) {
        return this[type];
    }

    _getStoredOtp() {
        return this.passOtp;
    }

    _setOtp(otp) {
        this.passOtp = otp;
        this.emit("change", "passOtp");
    }

    _setField(type, value, c_code, activeTab) {
        this[type] = value;
        if (activeTab) this["activeTab"] = activeTab;
        if (c_code) this["c_code"] = c_code;
        if (type == "otp") {
            this.errorMsg = "OTP sent successfully to your mobile no";
            this.emit("change", "otp");
        } else if (type == "errorMsg") this.emit("change", "errorMsg");
        else if (type === "mailSent") this.emit("change", "mailSent");
    }
    _storeNumber(data) {
        this.number = data;
    }
    _getNumber() {
        return this.number;
    }

    _showLoader(loader) {
        this.loader = loader;
        this.emit("change", "loader");
    }
    _getLoader() {
        return this.loader;
    }

    _handleEmitAutoDirect() {
        this.emit("change", "AUTO_DIRECT");
    }

    _getCountryCodeField() {
        return this.countryCode;
    }

    _setCountryCodeField(countryCode) {
        this.countryCode = countryCode;
        this.emit("change", "countryCode");
    }
    _getHappayIdField() {
        return this.happayIdField;
    }

    _setHappayIdField(happayIdField) {
        this.happayIdField = happayIdField;
        this.emit("change", "happayIdField");
    }

    _setEncryptionKey(publicKey) {
        this.encryptionKey = publicKey;
        this.emit("change", "encryptionKey");
    }

    _getEncryptionKey() {
        return this.encryptionKey;
    }

    _handleActions(action) {
        switch (action.type) {
            case "SET_USER_NAME": {
                this._setField("user", action.value);
                break;
            }
            case "SET_ANY_KEY": {
                this._setField(action.key, action.value, action.extra, action.activeTab);
                break;
            }
            case "LOGIN_LOADER": {
                this._showLoader(action.loader);
                break;
            }
            case "CLEAR_ALL": {
                this.initData();
                break;
            }
            case "SET_OTP": {
                this._setOtp(action.value);
                break;
            }
            case "COUNTRY_CODE": {
                this._setCountryCodeField(action.value);
                break;
            }
            case "HAPPAY_ID_KEY": {
                this._setHappayIdField(action.value);
                break;
            }
            case "SET_ENCRYPTION_KEY": {
                this._setEncryptionKey(action.value);
                break;
            }
        }
    }
}

const loginStore = new LoginStores();
if (process.env.NODE_ENV !== "production") window.loginStores = loginStore;
dispatcher.register(loginStore._handleActions.bind(loginStore));
export default loginStore;
